<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="commonTableStyles orderConfirmation">
            <van-nav-bar
                title="订单确认"
                left-text="应用"
                left-arrow
                @click-left="onClickLeft"
            >
                <template slot="right">
                    <van-popover
                        v-model="showStatePopover"
                        trigger="click"
                        :actions="actions"
                        @select="onSelect"
                        placement="bottom-end"
                    >
                        <template #reference>
                            <div class="state-btn">
                                {{ curQueryState.text }}<i class="iconfont iconjiantouxia"></i>
                            </div>
                        </template>
                    </van-popover>
                </template>
            </van-nav-bar>
            <van-search v-model="Keywords" placeholder="请输入搜索信息" @change="search"></van-search>
            <div class="time-sort">
                <a :class="{active:order_field=='submitted'}" @click="sortChange('submitted')">
                    订单时间
                    <i
                        :class="['iconfont',order_field=='submitted'&&order_by==1
                            ?'iconiconfontrectangle52rectangle52copy':'iconiconfontrectangle52rectangle521copy']"
                    ></i>
                </a>
                <a :class="{active:order_field=='arrival_time'}" @click="sortChange('arrival_time')">
                    要料时间
                    <i
                        :class="['iconfont',order_field=='arrival_time'&&order_by==1
                            ?'iconiconfontrectangle52rectangle52copy':'iconiconfontrectangle52rectangle521copy']"
                    ></i>
                </a>
            </div>
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                <van-list
                    v-model="isUpLoading"
                    :finished="finished"
                    finished-text="没有更多了!"
                    @load="onLoad"
                >
                    <ul class="list" v-if="orderData.length > 0">
                        <template v-for="(item, index) in orderData">
                            <li :key="index">
                                <div class="engineeringInfo" @click="openOrderDetails(item)">
                                    <h4 class="engineeringInfo_header">
                                        <span class="state" v-if="item.status == 0" style="background-color:#F85B5B;">未提交</span>
                                        <span class="state" v-if="item.status == 1" style="background-color:#FF6600;">待确定</span>
                                        <span class="state" v-if="item.status == 2" style="background-color:#D6010F;">退回</span>
                                        <span class="state" v-if="item.status == 3" style="background-color:#D6010F;">撤销</span>
                                        <span class="state" v-if="item.status == 4" style="background-color:#00A84B;">已确认</span>
                                        <span class="state" v-if="item.status == 5" style="background-color:#D6010F;">关闭</span>
                                        <span class="state" v-if="item.status == 6" style="background-color:#00A84B;">完成</span>
                                        <span class="headerName">{{ item.customer_name }}</span>
                                    </h4>
                                    <div class="engineeringInfo_content">
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                            <span>订单编号：{{ item.order_number }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_2.png" alt="">
                                            <span>工程名称：{{ item.project_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_2.png" alt="">
                                            <span>供货站点：{{ item.station_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                            <span>用料时间：{{ item.arrival_time }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                            <span>强度等级：{{ item.strength_grade_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_30.png" alt="">
                                            <span>预计方量：{{ item.quantity }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_3.png" alt="">
                                            <span>联系人：{{ item.xclxr_phone }}</span>
                                        </p>
                                        <button class="telephone" @click.stop="openContactInfo(item)"></button>
                                    </div>
                                </div>
                                <div class="btns">
                                    <button @click="openOrderDetails(item)" v-if="item.status < 2">
                                        <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                        订单确认
                                    </button>
                                    <button @click.stop="communicate(item.contract_number)">
                                        <img src="@/assets/images/icons/icon_27.png" alt="">
                                        沟通反馈
                                    </button>
                                </div>
                            </li>
                        </template>
                    </ul>
                </van-list>
            </van-pull-refresh>
            <van-action-sheet
                v-model="actionSheetShow"
                cancel-text="取消"
                class="contactInfo"
            >
                <h5>{{ contactInfo.xclxr }}</h5>
                <p @click="phone(contactInfo.xclxr_phone)">
                    联系电话：{{ contactInfo.xclxr_phone }}
                </p>
            </van-action-sheet>
        </div>
    </v-touch>
</template>

<script>

export default {
    // 订单确认、零售订单确认
    name: 'order-confirmation',
    components: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'order-confirmation');
        }
        next();
    },
    props: {},
    data() {
        return {
            pageID: '',
            // 联系人上拉菜单状态
            actionSheetShow: false,
            // 下拉login状态
            isLoading: false,
            // 上拉login状态
            isUpLoading: false,
            // 是否已加载完所有数据
            finished: false,
            // 当前任务联系方式
            contactInfo: '',
            // 订单数据集合
            orderData: [],
            // 上拉索引
            count: 1,
            // 列表总条数
            total: 0,
            // 记录上拉还是下拉
            slidingDirection: '',
            // 云信id
            accId: '',
            // 当前合同编号
            contractNumber: '',
            showStatePopover: false,
            // 通过 actions 属性来定义菜单选项
            actions: [{ text: '全部', value: '' }, { text: '未确认', value: 1 }, { text: '已确认', value: 4 }],
            curQueryState: {},

            // 排序字段submitted 默认用料时间  arrival_time
            order_field: 'arrival_time',
            // 排序类型 升序=1，降序=2
            order_by: 2,
            // 搜索关键词
            Keywords: '',
            pagesize: 5,
        };
    },
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.confirmCallback) {
            const orderNumber = this.$route.params.confirmCallback;
            const row = this.orderData.filter(item => item.order_number === orderNumber)[0];
            row.status = 4;
        }
    },
    created() {
        // retail = true, 零售订单确认
        if (this.$route.query.retail) {
            this.pageID = 'retail';
        }
        this.curQueryState = this.actions[0];
        // 转发原生回调函数
        window.callback_GetTeamsListInfo = this.callback_GetTeamsListInfo;
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 搜索关键字
        search() {
            this.count = 1;
            this.orderData = [];
            this.getOrderData();
        },
        // 切换排序
        sortChange(order_field) {
            if (this.order_field === order_field) {
                this.order_by = this.order_by === 2 ? 1 : 2;
            } else {
                this.order_field = order_field;
                this.order_by = 2;
            }
            this.search();
        },
        // 确定选择
        onSelect(action) {
            this.curQueryState = action;
            this.search();
        },
        // 返回上级菜单
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },
        // 打开联系人信息上拉菜单
        openContactInfo(data) {
            this.contactInfo = data;
            this.actionSheetShow = true;
        },
        // 打开订单详情
        openOrderDetails(data) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'orderDetails',
                params: {
                    pageID: this.pageID,
                    data: data,
                },
            });
        },
        // 沟通反馈
        communicate(id) {
            this.contractNumber = id;
            this.$axios
                .get('/interfaceApi/sale/contract_manager/get_contract_user_phone/' + this.contractNumber)
                .then(res => {
                    if (!res.netease_group_id) {
                        this.gitUserAccid(res);
                    } else {
                        const callMobileData = {
                            conversationId: res.netease_group_id,
                            name: res.group_name,
                            type: '1',
                        };
                        this.$callMobile('JYTeamsNative', 'GetConversationInfo', callMobileData);
                    }
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 获取联系人云信id
        gitUserAccid(data) {
            this.$axios
                .post('/interfaceApi/message/MessageNetease/get_accids', data.phones)
                .then(res => {
                    if (res.length > 0) {
                        const callMobileData = {
                            uids: res,
                            groupName: data.group_name,
                            type: '0',
                        };
                        this.$callMobile('JYTeamsNative', 'jyCreatedGroupWithContractInfo', callMobileData);
                    } else {
                        this.$toast('当前订单暂时无法进行沟通！');
                    }
                }).catch(error => {
                    this.isloading = false;
                    this.$dialog({ message: error });
                });
        },
        // 原生调js回传群组json
        callback_GetTeamsListInfo(chartGroupJson) {
            const groupData = JSON.parse(chartGroupJson).teams[0];
            if (groupData.teamid && groupData.teamid !== 'undefined') {
                const res = this.addContractNetease(groupData.teamid);
                if (res) {
                    this.groupChat(groupData);
                }
            }
        },
        // 合同关联云信群组
        addContractNetease(teamid) {
            return this.$axios.put('/interfaceApi/sale/contract_manager/add_contract_netease/' + this.contractNumber + '/' + teamid);
        },
        // 点群组列表进入群组聊天
        groupChat(data) {
            const callMobileData = {
                conversationId: data.teamid,
                name: data.teamName,
                type: '1',
            };
            this.$callMobile('JYTeamsNative', 'GetConversationInfo', callMobileData);
        },
        // 下拉刷新
        onRefresh() {
            this.slidingDirection = 'down';
            this.count = 1;
            this.getOrderData();
            this.count++;
        },
        // 上拉加载更多
        onLoad() {
            this.slidingDirection = 'up';
            this.getOrderData();
            this.count++;
        },
        // 拉取订单数据
        getOrderData() {
            const user_id = this.$takeTokenParameters('Uid');
            let address = '';
            if (this.pageID === 'retail') {
                address = '/productorder/retailorder_list';
            } else {
                address = '/productorder/getpage_client';
            }
            const url = `/interfaceApi/production${address}?`
                + `user_id=${user_id}&status=${this.curQueryState.value}`
                + `&order_field=${this.order_field}&order_by=${this.order_by}`
                + `&keyword=${this.Keywords}&pageindex=${this.count}`
                + `&pagesize=${this.pagesize}`;
            this.$axios
                .get(url)
                .then(res => {
                    this.total = res.total;
                    if (this.orderData.length < 1 || this.slidingDirection === 'down') {
                        this.orderData = res.rows;
                        this.finished = false;
                    } else {
                        res.rows.forEach(item => {
                            this.orderData.push(item);
                        });
                    }
                    if (this.orderData.length >= this.total) {
                        this.finished = true;
                    }
                    this.isLoading = false;
                    this.isUpLoading = false;
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 调用打电话功能
        phone(phoneNumber) {
            this.$callMobile('JYTeamsNative', 'jyMakePhoneCall', phoneNumber);
            this.actionSheetShow = false;
        },
    },
};
</script>
<style lang="stylus">
.van-popover__action
    width 90rpx;
    height 0.4rpx;
.orderConfirmation
    height 100%
    background #F0F0F0
    .state-btn
        display flex
        justify-content center
        align-items center
        width: 72rpx;
        height: 28rpx;
        border-radius: 2rpx;
        border: 1px solid rgba(255, 255, 255, 0.14);
        color #fff;
        position relative
        .iconjiantouxia
            position absolute
            right 6rpx;
            font-size 8rpx;
    .time-sort
        width: 100%;
        height: 45rpx;
        background: #FFFFFF;
        display flex
        justify-content space-around;
        align-items center
        a
            width 49%;
            display flex
            justify-content center
            font-size 14rpx;
            color #666666;
            &.active
                color #3495FB
            &:nth-child(1)
                border-right 1px solid #F0F0F0
            .iconfont
                margin-left 2rpx;
                font-size 12rpx;
                display flex
                align-items center
    .van-pull-refresh
        margin-top 10rpx;
        height calc(100% - 135rpx)
        overflow-y auto
        .list
            height calc(100% - 45rpx)
            overflow-y auto
            background #F0F0F0
            padding 15rpx
            padding-bottom 0
            li
                width 100%
                background #fff
                overflow hidden
                margin-bottom 15rpx
                .telephone
                    width 25rpx
                    height 25rpx
                    background url(./../../../assets/images/clueManagement/phone@2x.png)
                    background-size 100% 100%
                    border none
                    position absolute
                    right 20rpx
                    bottom 70rpx
                .btns
                    padding 0 6rpx
                    text-align center
                    margin-bottom 14rpx
                    button
                        border 1px solid #D7D7D7
                        border-radius 4rpx
                        background #fff
                        height 32rpx
                        margin 0 25rpx
                        font-size 14rpx
                        color #333333
                        width calc((100% - 100rpx)/2)
                        img
                            width 16rpx
                            vertical-align middle
                            margin-top -4rpx
    .contactInfo
        h5,p
            font-size 16rpx
            line-height 45rpx
            text-align center
        h5
            color #333333
            background #F8F8F8
        p
            color #0189FC
            border-bottom 1px solid  #F0F0F0
    .screen
        height 100%
        section
            height calc(100% - 45rpx)
            overflow: scroll;
            -webkit-overflow-scrolling: touch;
            dt
                font-size 14rpx
            dd
                .van-cell-group
                    &:after
                        border 1px solid #f0f0f0
                    .van-cell
                        padding 5rpx 16rpx
                        margin-bottom 15rpx
                i
                    font-size 12rpx
                    color #ccc
            .user
                dd
                    overflow hidden
                    div
                        float left
                        width 42rpx
                        margin-top 14rpx
                        margin-right 34rpx
                        img
                            display block
                            width 42rpx
                            height 42rpx
                            border-radius 50%
                        span
                            display block
                            width 100%
                            font-size 12rpx
                            text-align center
                            line-height 24rpx
                            color #979ea7
                            margin 0
                    button
                        width 42rpx
                        height 42rpx
                        border-radius 50%
                        border none
                        color #666666
                        background #F1F1F1
                        font-size 24rpx
                        line-height 40rpx
                        margin-top 14rpx
            .time
                span,input
                    float left
                    margin-top 14rpx
                span
                    width 28rpx
                    line-height 32rpx
                    color #D7D7D7
                    text-align center
                input
                    width calc((100% - 28rpx)/2)
                    height 32rpx
                    border 1px solid #F0F0F0
                    padding-left 6rpx
                    font-size 14rpx

</style>
